import { memo, useMemo } from "react";

import type { SearchedContent } from "@/components/features/faq/ui/hooks/search-contents/type";

import { Category } from "./components";

type Props = {
	hostContents: SearchedContent;
	guestContents: SearchedContent;
};
export const CategorySection = memo(({ hostContents, guestContents }: Props) => {
	const canShowHostContents = useMemo(() => hostContents.length > 0, [hostContents]);
	const canShowGuestContents = useMemo(() => guestContents.length > 0, [guestContents]);

	return (
		<div className="sticky top-20 hidden h-[450px] min-w-[240px] sm:block">
			<a href="#top">
				<h3 className="text-xl font-bold">カテゴリー</h3>
			</a>
			{canShowHostContents && <Category title="ホスト" contents={hostContents} />}
			{canShowGuestContents && <Category title="ゲスト" contents={guestContents} />}
		</div>
	);
});
CategorySection.displayName = "CategorySection";
